module.exports = __webpack_public_path__ + "static/media/south-africa.8dc48856.svg";